// clientErrorLog.ts — EV-839
// Best-effort "send the debug log to Neon" so we can SEE what failed on a real
// device: which page, what time, which (auth?) user, which build — instead of
// guessing from "it doesn't work". POSTs to analytics.client_errors via the
// backend. NEVER throws (logging must not cascade into a second failure).
import { getApiBaseUrl } from '../config/region';

// Bumped every build that matters — lets us tell from the Neon row whether a
// device is running the latest code or a stale cached chunk (the recurring bug).
export const APP_VERSION = 'v69.256';

type ClientErrorPayload = {
  kind?: string;                  // 'error' | 'crash' | 'grouping_diag' | ...
  error_name?: string;
  error_message?: string;
  error_stack?: string;
  component_stack?: string;
  extra?: Record<string, any>;    // arbitrary diagnostic context
};

function isAuthed(): boolean {
  try {
    return !!(localStorage.getItem('token') || localStorage.getItem('authToken') || localStorage.getItem('hl_token'));
  } catch { return false; }
}

function currentUserId(): string | null {
  try {
    const raw = localStorage.getItem('user') || localStorage.getItem('hl_user');
    if (raw) { const u = JSON.parse(raw); return u?.id != null ? String(u.id) : (u?._id || u?.email || null); }
  } catch { /* ignore */ }
  return null;
}

function regionGuess(): string {
  try {
    const h = window.location.hostname;
    if (h.includes('vn.')) return 'vn';
    if (h.includes('thai.')) return 'th';
    if (h.includes('my.')) return 'my';
  } catch { /* ignore */ }
  return 'vn';
}

export function logClientError(payload: ClientErrorPayload): void {
  try {
    const body = {
      kind: payload.kind || 'error',
      url: (() => { try { return window.location.href; } catch { return null; } })(),
      route: (() => { try { return window.location.pathname + window.location.search; } catch { return null; } })(),
      error_name: payload.error_name || null,
      error_message: payload.error_message || null,
      error_stack: payload.error_stack || null,
      component_stack: payload.component_stack || null,
      user_id: currentUserId(),
      is_auth: isAuthed(),
      region: regionGuess(),
      app_version: APP_VERSION,
      extra: payload.extra || null,
    };
    const url = `${getApiBaseUrl()}/client-errors`;
    // sendBeacon survives page unload / crash; fall back to fetch keepalive.
    const json = JSON.stringify(body);
    if (navigator.sendBeacon) {
      const blob = new Blob([json], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: json, keepalive: true }).catch(() => {});
    }
  } catch {
    // swallow — diagnostics must never break the app
  }
}
